module.exports = __webpack_public_path__ + "static/media/pdfcourt-og.9bfb84ea.png";